exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".editControls .editInput{display:inline-block;border:none;border-bottom:1px solid #888;width:3em;text-align:center}.editControls .btn.btn-link.saveButton{color:#42af14;padding:0;position:relative;bottom:1px}.editControls .form-control.scoreEdit{display:inline-block;width:3em;height:25px;padding:5px;margin-left:10px}.editControls .editRow{margin-bottom:10px}.editControls .editRow:last-child{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/controls/edit_controls.scss
// module id = 1510
// module chunks = 0